<p-card>
    <p-tabMenu [model]="tabs" />
    <div class="mt-3">
        <router-outlet></router-outlet>
    </div>
</p-card>
